import React from "react";
import GridTable from "pages/_components/GridTable/GridTable";
import I18n from "pages/_components/I18n";
import { func, bool } from "prop-types";

import EcheqCheckbox from "./EcheqCheckbox";

const EcheqTitleColumns = ({ allEcheqsAreSelected, handleCheckAllEcheqs, canCheck, disableCheck }) => (
    <>
        {canCheck && (
            <GridTable.Data columnStart={1} rowStart={1} rowWidth={1}>
                <EcheqCheckbox
                    name="title-table"
                    disabled={disableCheck}
                    checked={allEcheqsAreSelected}
                    onChange={handleCheckAllEcheqs}
                />
            </GridTable.Data>
        )}
        <GridTable.Data alignX="center" alignY="center" columnStart={canCheck ? 2 : 1} rowStart={1} rowWidth={1}>
            <I18n component="span" id="discounts.echeqTable" defaultValue="Nº Echeq" />
        </GridTable.Data>
        <GridTable.Data alignX="center" alignY="center" columnStart={canCheck ? 3 : 2} rowStart={1} rowWidth={1}>
            <I18n component="span" id="discounts.echeqTable" defaultValue="Carácter" />
        </GridTable.Data>
        <GridTable.Data alignX="center" alignY="center" columnStart={canCheck ? 4 : 3} rowStart={1} rowWidth={1}>
            <I18n component="span" id="discounts.echeqTable" defaultValue="Recibido de" />
        </GridTable.Data>
        <GridTable.Data alignX="center" alignY="center" columnStart={canCheck ? 5 : 4} rowStart={1} rowWidth={1}>
            <I18n component="span" id="discounts.echeqTable" defaultValue="CUIT/CUIL" />
        </GridTable.Data>
        <GridTable.Data alignX="center" alignY="center" columnStart={canCheck ? 6 : 5} rowStart={1} rowWidth={1}>
            <I18n component="span" id="discounts.echeqTable" defaultValue="Monto" />
        </GridTable.Data>
        <GridTable.Data alignX="center" alignY="center" columnStart={canCheck ? 7 : 6} rowStart={1} rowWidth={1}>
            <I18n component="span" id="discounts.echeqTable" defaultValue="Fecha de pago" />
        </GridTable.Data>
        <GridTable.Data alignX="center" alignY="center" columnStart={canCheck ? 8 : 7} rowStart={1} rowWidth={1}>
            <I18n component="span" id="discounts.echeqTable" defaultValue="Estado" />
        </GridTable.Data>
    </>
);

EcheqTitleColumns.propTypes = {
    allEcheqsAreSelected: bool.isRequired,
    handleCheckAllEcheqs: func.isRequired,
    canCheck: bool.isRequired,
    disableCheck: bool.isRequired,
};

export default EcheqTitleColumns;
